module.exports = __webpack_public_path__ + "static/media/Galdisa_Oil roasted peanut snack with salt.d7d065b5.pdf";